export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6501.9c5d3ee9.jpg";